import { DataBean } from "../DataBean";

export class SocialSecurityTemplate extends DataBean {



    public async deleteSocialSecurityTemplate(idSocialSecurityTemplate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSocialSecurityTemplate_Number", [idSocialSecurityTemplate]);
    }
    public async importSocialSecurityTemplate(idSocialSecurityTemplate: any, filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importSocialSecurityTemplate_Number_String_String_String", [idSocialSecurityTemplate, filename, directory, dataStore]);
    }

    public async exportSocialSecurityTemplate(idSocialSecurityTemplate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportSocialSecurityTemplate_Number", [idSocialSecurityTemplate]);
    }
    public async getSocialSecurityTemplateCatalog(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecurityTemplateCatalog_Number", [args]);
    }

}